import { CANVAS } from "@/apollo/queries/canvas";
import { USER_ENTITLEMENTS } from "@/apollo/queries/user";
import ValuePlanPageMetaTags, {
  tags,
} from "@/components/MetaTags/ValuePlanPageMetaTags";
import { useBreadcrumbs } from "@/hooks";
import config from "@/lib/config";
import { CANVAS_PAGE_LIMIT } from "@/lib/constants";
import routes from "@/lib/routes";
import withMiddlewares from "@/middlewares/withMiddlewares";
import dynamic from "next/dynamic";
import { useEffect } from "react";
const Canvas = dynamic(() => import("@/components/Canvas"));

export default function ValuePlan() {
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([
      { text: "ホーム", href: routes.home },
      { text: config.valuePlan.text },
    ]);
  }, []);

  return (
    <>
      <ValuePlanPageMetaTags />
      <Canvas idKey={config.canvas.valuePlan.vod} />
    </>
  );
}

export const getServerSideProps = withMiddlewares(
  async ({}, { serverProps, error, apolloClient }) => {
    await apolloClient.query({
      query: CANVAS,
      variables: {
        idKey: config.canvas.valuePlan.vod,
        offset: 0,
        limit: CANVAS_PAGE_LIMIT,
      },
    });
    await apolloClient.query({
      query: USER_ENTITLEMENTS,
    });

    const metatags = tags();
    return {
      props: {
        ...serverProps,
        error,
        metatags,
        initialApolloState: apolloClient.cache.extract(),
      },
    };
  }
);
